export enum ERoute {
  Messages = 'messages',
  Spam = 'spam',
  Archive = 'archive',
  Unread = 'unread',
}

export type TRoute = `${ERoute}`;
